import { useModal } from '@/hooks'
import { backgroundPattern, zheka } from '@/images'
import React from 'react'
import Button from '../Button'
import Container from '../Container'
import Title from '../Title'
import style from './styles/have_questions.module.scss'

const HaveQuestions = (): React.ReactElement => {
  const { openModal } = useModal()

  const handleClick = (): void => {
    openModal('feedback')
  }
  return (
    <section className={style.questions}>
      <div
        className={style.questions_bg}
        style={{ backgroundImage: `url(${String(backgroundPattern)})` }}
      >
        <Container className={style.questions_wrap}>
          <img
            src={zheka}
            width='390px'
            height='407px'
            alt='Жэка'
            className={style.questions__image}
          />
          <div className={style.questions_content}>
            <Title type='h2' theme='h1' className={style.questions__title}>
              Остались вопросы?
            </Title>
            <p className={style.questions__text}>
              Задайте вопрос прямо сейчас, мы будем рады вам ответить!
            </p>
            <Button
              size='extralarge'
              highlight
              wide
              onClick={handleClick}
              className={style.questions__button}
            >
              Задать вопрос
            </Button>
          </div>
        </Container>
      </div>
    </section>
  )
}

export default HaveQuestions
